'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_AVAILABILITY_MESSAGE_TIMEOUT = exports.ADD_AVAILABILITY_MESSAGE_TIMEOUT = 'ADD_AVAILABILITY_MESSAGE_TIMEOUT';